import { gql } from '@apollo/client';
export const composerCategoriesQuery = gql `
  query ComposerCategories {
    categories: categories2(orderBy: [{ order: asc }]) {
      id
      metadata {
        id
        title
        marketLocaleCode
      }
    }
  }
`;
